module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tokens.length > 0) ? _c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("\n            Authorized Applications\n        ")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tsearch),
      callback: function($$v) {
        _vm.tsearch = $$v
      },
      expression: "tsearch"
    }
  })], 1)], 1), _vm._v(" "), (_vm.tokens.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.tokens,
      "search": _vm.tsearch,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "id"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            attrs: {
              "align": "left"
            },
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', [_vm._v("arrow_upward")]), _vm._v("\n                            " + _vm._s(header.text) + "\n                        ")], 1)
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(props.item.client.name) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(props.item.client.uid) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(props.item.client.scopes) + "\n                        ")]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "error",
          attrs: {
            "small": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.revoke(props.item)
            }
          }
        }, [_vm._v("\n                                Revoke\n                            ")])], 1)])]
      }
    }])
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47de78f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/passport/AuthorizedClients.vue
// module id = 322
// module chunks = 0